import { Overlay } from '@angular/cdk/overlay';
import { PlatformLocation } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import swal from 'sweetalert2';
import { DetalheProdutoModalComponent } from '../modals/detalhe-produto-modal/detalhe-produto-modal.component';
import { DigitaCampoModalComponent } from '../modals/digita-campo-modal/digita-campo-modal.component';
import { ProdutosModalComponent } from '../modals/produtos-modal/produtos-modal.component';
import { Cliente } from '../models/cliente';
import { Comissao } from '../models/comissao';
import { StatusDoPedido, TipoDeLogAcesso, TipoFiltroProduto } from "../models/enum";
import { Fileira } from '../models/fileira';
import { Fornecedor } from '../models/fornecedor';
import { Pedido, ItemPedido, ItemDesc } from '../models/pedido';
import { ProdutoDesconto, Produto } from '../models/produto';
import { ProdutoFornecedorValor } from '../models/produto-fornecedor-valor';
import { VendaEntrega } from '../models/venda-entrega';
import { CadastrarEstruturaComponent } from '../pedido/cadastrar-estrutura/cadastrar-estrutura.component';
import { CarregandoService } from '../services/carregando.service';
import { ClienteService } from '../services/cliente.service';
import { ComissaoService } from '../services/comissao.service';
import { CondicaoDePagamentoService } from '../services/condicao-de-pagamento.service';
import { EnderecoService } from '../services/endereco.service';
import { FormaDePagamentoService } from '../services/forma-de-pagamento.service';
import { FornecedorService } from '../services/fornecedor.service';
import { FuncionarioService } from '../services/funcionario.service';
import { GlobalService } from '../services/global.service';
import { IbgeService } from '../services/ibge.service';
import { LogAcessoService } from '../services/log-acesso.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PedidoService } from '../services/pedido.service';
import { PremissasService } from '../services/premissas.service';
import { ProdutoService } from '../services/produto.service';
import { RelatorioService } from '../services/relatorio.service';
import { UtilitarioService } from '../services/utilitario.service';
import { ViaCepService } from '../services/via-cep.service';
import { LogAcesso } from '../models/log-acesso';
import { ClientesModalComponent } from '../modals/clientes-modal/clientes-modal.component';
import { UsuarioLogado } from '../models/usuario-logado';
import { EstoqueProdutoModalComponent } from '../modals/estoque-produto-modal/estoque-produto-modal.component';
import { PremissasSistema } from '../models/premissas-sistema';
import { ProdutosV2ModalComponent } from "../modals/produtos-v2-modal/produtos-v2-modal.component";
import { Ibge } from '../models/ibge';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

// jquery
declare const $: any;

@Component({
  selector: 'app-avulso',
  templateUrl: './avulso.component.html',
  styleUrls: ['./avulso.component.scss'],
})
export class AvulsoComponent implements OnInit, AfterViewInit, OnDestroy {
  vendedor = undefined;
  limDesc = undefined;

  respostas = [];

  idOrcamento: string;
  fornecedorAnterior;
  cliente: Cliente;
  vendedorSelecionado = undefined;
  orcamento: Pedido = new Pedido();
  // paineis: Painel[] = [];
  fileiras: Fileira[] = [];
  novaFileira: Fileira = new Fileira();
  // novoPainel: Painel = new Painel();
  itens: ItemPedido[] = [];

  descontoMaximo = 0;
  limiteDescontoUsuario = 0;
  limiteDescontoUsuarioLogado = 0;
  comissao: Comissao;

  intPodeAlterarCD = false;
  vendPodeAlterarCD = true;

  comprovante;
  confirmar = false;

  // txFrete = 0;
  validaDesconto = false;
  StatusDoPedido = StatusDoPedido;

  multiFornecedores = false;
  fornecedorSelecionado;

  public MASKS = MASKS;

  integrador = false;

  customPatterns = {
    V: { pattern: new RegExp('(,|[0-9]|-|\\.)') },
    0: { pattern: new RegExp('[0-9]') },
  };

  verCustos = undefined;

  usuarioLogado: UsuarioLogado;

  texto = '';

  titulo = '';

  clienteFaturamento: Cliente;
  mostrarValores = false;
  enderecoDeEntrega: VendaEntrega = new VendaEntrega();
  pesoBruto = 0;
  mostrarCodErp: false;
  usarPrecoAvulso: false;
  fornecedores: Fornecedor[] = [];

  idFornecedor: number;
  pCentroDistribuicao = false;
  nome: string;

  pUsarAcrescimo = false;
  cds: Fornecedor[] = [];

  cdAnterior;

  mostrarMsgTrocaCD = { valor: false, msg: '' };
  podeVerEstoque = false;
  administrador: boolean = false;
  bloquearSistema: boolean = false;
  vendaProgramada = false;

  premissasSistema: PremissasSistema = new PremissasSistema();

  estadoSelecionado = undefined;
  cidadeSelecionado = undefined;

  cidade: Ibge;
  cidades$: Observable<Ibge[]>;
  cidadesLoading = false;
  cidadesInput$ = new Subject<string>();

  constructor(
    public dialog: MatDialog,
    private funcionarioService: FuncionarioService,
    private comissaoService: ComissaoService,
    private globalService: GlobalService,
    private viaCepService: ViaCepService,
    private ibgeService: IbgeService,
    private route: ActivatedRoute,
    private router: Router,
    private pedidoService: PedidoService,
    private clienteService: ClienteService,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private formadePagamentoService: FormaDePagamentoService,
    public utilitarioService: UtilitarioService,
    private condicaoDePagamentoService: CondicaoDePagamentoService,
    private enderecoService: EnderecoService,
    private produtoService: ProdutoService,
    private overlay: Overlay,
    private relatorioService: RelatorioService,
    private logAcessoService: LogAcessoService,
    private platformLocation: PlatformLocation,
    private premissasService: PremissasService,
    private fornecedorService: FornecedorService
  ) { }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');
    this.premissasService.consultarCentroDeDistribuicao().subscribe(f => {
      this.pCentroDistribuicao = f.valor;

      if (this.pCentroDistribuicao) {
        this.buscarIntPodeAlterarCD();
        this.buscarCDs();
      }

      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
    }, (erro) => {
      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  async buscarVendPodeAlterarCD() {
    try {
      this.carregandoService.mostra('buscarVendPodeAlterarCD');
      this.vendPodeAlterarCD = await this.funcionarioService.consultaPodeAlterarCD().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarVendPodeAlterarCD');
    }
  }

  buscarDescricaoCD() {
    if (this.cliente && this.cliente.idCD !== null && this.cliente.idCD !== undefined
      && this.cds && this.cds.some(p => p.id === this.cliente.idCD)) {
      return this.cds.find(p => p.id === this.cliente.idCD).descricao;
    } else {
      return '';
    }
  }

  buscarPremissasBloqueioSistema() {
    this.carregandoService.mostra('buscarBloqSist');
    this.premissasService.consultarBloqSistManuProd().subscribe(data => {
      this.bloquearSistema = data;
      this.carregandoService.esconde('buscarBloqSist');
    }, (erro) => {
      this.carregandoService.esconde('buscarBloqSist');
      this.notificacaoService.erro(erro);
    });
  }

  buscarPremissaUsarAcrescimo() {
    this.carregandoService.mostra('buscarPremissaUsarAcrescimo');
    this.premissasService.consultarUsarAcrescimo().subscribe(f => {
      if (f.valor) {
        this.pUsarAcrescimo = true;
      }

      this.carregandoService.esconde('buscarPremissaUsarAcrescimo');
    }, (erro) => {
      this.carregandoService.esconde('buscarPremissaUsarAcrescimo');
      this.notificacaoService.erro(erro);
    });
  }

  buscarPremissaVendaProgramada() {
    this.carregandoService.mostra('buscarPremissaVendaProgramada');
    this.premissasService.consultarVendaProgramada().subscribe(f => {
      if (f.valor) {
        this.vendaProgramada = true;
      }

      this.carregandoService.esconde('buscarPremissaVendaProgramada');
    }, (erro) => {
      this.carregandoService.esconde('buscarPremissaVendaProgramada');
      this.notificacaoService.erro(erro);
    });
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: { cliente: Cliente, vendedor: any, limDesc: any }) => {
      if (result) {
        this.cliente = result.cliente;
        this.descontoMaximo = result.limDesc ? result.limDesc : this.usuarioLogado.limDesc;
        this.vendedor = result.vendedor;
        this.limDesc = result.limDesc;

        if (!this.pCentroDistribuicao || (this.pCentroDistribuicao && !this.premissasSistema.habilitarCDPorCidade)) {
          this.estadoSelecionado = this.cliente.uf;
          this.cidadeSelecionado = this.cliente.ibge;
        }

        this.buscarCidades();

        if (this.pCentroDistribuicao) {

          if (this.premissasSistema.habilitarCDPorCidade) {

            this.cliente.idCD = null;
            this.cdAnterior = null;
            this.idFornecedor = null;
          } else {
            this.idFornecedor = this.cliente.idCD;
            this.cdAnterior = this.cliente.idCD;
          }
        }
      }
    }
    );
  }

  buscarIntPodeAlterarCD() {
    this.carregandoService.mostra('buscarIntPodeAlterarCD');
    this.premissasService.consultarIntPodeAlterarCD().subscribe(
      (f) => {
        this.intPodeAlterarCD = f.valor;
        if (this.intPodeAlterarCD) {
          this.buscarMostrarMsgTrocaCD();
        }
        this.carregandoService.esconde('buscarIntPodeAlterarCD');
      },
      (erro) => {
        this.carregandoService.esconde('buscarIntPodeAlterarCD');
        this.notificacaoService.erro(erro);
      }
    );
  }

  retornaClasseTipoProduto(tipo) {
    switch (tipo.toString()) {
      case '2':
        return 'badge-primary';
      case '3':
        return 'badge-secondary';
      case '4':
        return 'badge-success';
      case '5':
        return 'badge-danger';
      case '6':
        return 'badge-dark';
      case '1':
        return 'badge-info';
      case '8':
        return 'badge-warning';
      case '9':
        return 'badge-danger';

      default:
        return 'badge-info';
    }
  }

  retornaLetraTipoProduto(tipo) {
    switch (tipo.toString()) {
      case '2':
        return 'P';
      case '3':
        return 'I';
      case '4':
        return 'S';
      case '5':
        return 'C';
      case '6':
        return 'E';
      case '1':
        return 'O';
      case '7':
        return 'K';
      case '8':
        return 'T';
      case '9':
        return 'B';

      default:
        return 'O';
    }
  }

  retornaOrdemTipoProduto(tipo) {
    switch (tipo.toString()) {
      case '7':
        return 0;
      case '2':
        return 1;
      case '3':
        return 2;
      case '4':
        return 3;
      case '5':
        return 4;
      case '6':
        return 5;
      case '8':
        return 6;
      case '1':
        return 7;

      default:
        return 6;
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  ordenaProdutos() {
    this.carregandoService.mostra('ordenaProduto');
    this.itens = this.itens.sort((a, b) => {
      return this.compare(
        this.retornaOrdemTipoProduto(a.produtoTela.familia),
        this.retornaOrdemTipoProduto(b.produtoTela.familia),
        true
      );
    });
    this.carregandoService.esconde('ordenaProduto');
  }

  async ngOnInit() {

    this.loadCidade();

    const userId = await (await this.globalService.consultaUsuario()).id;
    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.administrador = await this.globalService.administrador();

    this.integrador = await this.globalService.integrador();

    if (!this.integrador) {
      this.buscarVendPodeAlterarCD();
    }

    await this.buscarPremissasSistema();

    if (this.integrador && this.premissasSistema.avulsoSomenteInterno) {
      this.router.navigate(['/']);
    }

    this.buscarMultiFornecedores();
    this.buscarVerPrecosProdutos();
    this.buscarMostrarCodErp();
    this.buscarUsarPrecoAvulso();
    this.buscarPremissaCentroDeDistribuicao();
    this.buscarPremissaUsarAcrescimo();
    this.consultaPodeVerEstoque(userId);
    this.buscarPremissasBloqueioSistema();
    this.buscarPremissaVendaProgramada();

    this.descontoMaximo = this.integrador
      ? 0
      : this.usuarioLogado.limDesc;
    this.verCustos = this.usuarioLogado.verCustos;

    this.titulo = 'Avulso';

    this.texto = 'Orçamento';

    if (this.integrador) {
      this.inserirLogAcessoTela();
    }

    this.orcamento.obs2 = '';
    this.orcamento = new Pedido();
    this.itens = [];
    this.orcamento.data = new Date();
    this.orcamento.da = 0;
    this.orcamento.valorDa = 0;
    this.orcamento.percentual = 0;
    this.orcamento.flag = 4;
    this.orcamento.cupomDesconto = null;
    this.orcamento.tipoFrete = 0;
    this.orcamento.frete = 0;
    this.orcamento.valorServico = 0;
    this.orcamento.financiamento = true;
    this.orcamento.dispEstoque = true;

    if (this.integrador) {
      this.orcamento.cliente = this.usuarioLogado.id;
      this.buscarCliente();
    } else {
      this.vendedorSelecionado = this.usuarioLogado.id;
    }

    const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
  }

  ngAfterViewInit() {
    this.utilitarioService.rodaScriptTabEnter();
  }

  consultaPodeVerEstoque(id: number) {
    this.carregandoService.mostra('podeVerEstoque');
    this.funcionarioService.consultaPodeVerEstoque(id).subscribe(resp => {
      this.podeVerEstoque = resp;
      this.carregandoService.esconde('podeVerEstoque');
    }, (erro) => {
      this.carregandoService.esconde('podeVerEstoque');
      console.error(erro);
      this.notificacaoService.erro('Não foi possível verificar se o usuário pode ver o estoque.');
    });
  }

  gerarLogAcesso() {
    const logAcesso: LogAcesso = {
      tipo: TipoDeLogAcesso.Avulso,
    };

    this.logAcessoService.Salvar(logAcesso).subscribe(() => { });
  }

  // abre o modal de pesquisa de produtos
  pesquisarProdutos() {
    this.gerarLogAcesso();

    let idFornecedorPainel;

    if (this.multiFornecedores) {
      idFornecedorPainel = this.fornecedorSelecionado;
    }

    if (this.pCentroDistribuicao) {

      if (this.cliente.idCD === null || this.cliente.idCD === undefined) {
        return;
      }

      idFornecedorPainel = this.cliente.idCD;
    }

    let dialogRef;
    const config = {
      width: $('body').width().toString() + 'px',
      // passa os produtos já selecionados
      data: {
        selecionavel: true,
        produtos: this.itens,
        somenteKit: false,
        producaoPorPainel: 0,
        quantidadeDePaineis: 0,
        potenciaPainel: 0,
        potTotal: 0,
        semKit: true,
        origem: 2,
        idFornecedorPainel: idFornecedorPainel,
        msgAlterarCD: this.integrador && this.intPodeAlterarCD && this.pCentroDistribuicao && this.cliente && this.mostrarMsgTrocaCD.valor && this.mostrarMsgTrocaCD.msg ? this.mostrarMsgTrocaCD.msg : undefined
      },
      panelClass: 'modal-card',
      maxHeight: '90vh',
    };

    if (this.premissasSistema.filtroProduto === TipoFiltroProduto.Agrupamento) {
      dialogRef = this.dialog.open(ProdutosModalComponent, config);
    } else {
      dialogRef = this.dialog.open(ProdutosV2ModalComponent, config);
    }

    // quando fecha o modal
    dialogRef.afterClosed().subscribe((result: ItemPedido[]) => {
      if (result) {
        // verifica se é para excluir algum item
        if (
          this.itens.some(
            (p) =>
              !result.some(
                (r) => r.produtoTela.idProduto === p.produtoTela.idProduto
              )
          )
        ) {
          this.itens
            .filter(
              (p) =>
                !result.some(
                  (r) => r.produtoTela.idProduto === p.produtoTela.idProduto
                )
            )
            .forEach(async (it) => {
              await this.excluirProduto(it);
            });
        }


        // atualiza a lista de produtos
        result.forEach(async (p) => {
          if (
            this.itens.some(
              (ps) => ps.produtoTela.idProduto === p.produtoTela.idProduto
            )
          ) {
            this.itens.find(
              (ps) => ps.produtoTela.idProduto === p.produtoTela.idProduto
            ).qt = p.qt;
            await this.atualizaValorProduto(
              this.itens.find(
                (ps) => ps.produtoTela.idProduto === p.produtoTela.idProduto
              )
            );
          } else {
            this.itens.push(p);
            this.ordenaProdutos();
            await this.atualizaValorProduto(p);
          }
        });

      }
    });
  }

  async validaQtd(item: ItemPedido) {
    if (
      item.qt === null ||
      item.qt === undefined ||
      Number.isNaN(item.qt) ||
      item.qt < 0
    ) {
      item.qt = 1;
      await this.atualizaValorProduto(item);
    } else if (Number(item.qt) > 200000) {
      item.qt = 200000;
      await this.atualizaValorProduto(item);
    }
  }

  async atualizaValorProduto(item: ItemPedido) {

    let descontar = false;
    let desconto = 0;

    if (item.qt !== item.qtAnterior) {
      // && Number(item.qt) > Number(item.produtoTela.qtestoque)) {
      item.qtAnterior = item.qt;
    }

    if (item.produtoTela.familia === 2 || item.produtoTela.familia === 3) {
      desconto = await this.buscarDescontoProduto(item);
      descontar = true;
      item.itemDesc.preco = this.usarPrecoAvulso ? item.produtoTela.precoAvulso : item.produtoTela.precoVenda;
    }

    if (this.usarPrecoAvulso) {
      item.pUnitario =
        descontar
          ? Number(
            (
              item.produtoTela.precoAvulso -
              (item.produtoTela.precoAvulso *
                desconto) /
              100
            ).toFixed(2)
          )
          : Number(item.produtoTela.precoAvulso.toFixed(2));
    } else {
      item.pUnitario =
        descontar
          ? Number(
            (
              item.produtoTela.precoVenda -
              (item.produtoTela.precoVenda * desconto) /
              100
            ).toFixed(2)
          )
          : Number(item.produtoTela.precoVenda.toFixed(2));
    }
    item.vTotal = Number((item.pUnitario * item.qt).toFixed(2));
    this.atualizaValores();
  }

  async buscarDescontoProduto(item: ItemPedido) {
    try {
      this.carregandoService.mostra('buscarDescontoProduto');

      if (item.itemDesc === null || item.itemDesc === undefined)
        item.itemDesc = new ItemDesc();

      item.itemDesc.descontos = item.itemDesc.descontos === null || item.itemDesc.descontos === undefined ? await this.produtoService.consultarDescontos(item.produtoTela.idProduto).toPromise() : item.itemDesc.descontos;

      if (item.itemDesc.descontos.some(p => item.qt >= p.qtdIni &&
        item.qt <= p.qtdFim)) {
        this.carregandoService.esconde('buscarDescontoProduto');
        return item.itemDesc.descontos
          .find(p => item.qt >= p.qtdIni &&
            item.qt <= p.qtdFim).desco;
      } else {
        this.carregandoService.esconde('buscarDescontoProduto');
        return 0;
      }
    } catch (erro) {
      this.carregandoService.esconde('buscarDescontoProduto');
      this.notificacaoService.erro(erro);
      return 0;
    }
  }

  async aumentaQtdProduto(item: ItemPedido) {
    if (item.qt + 1 <= 10000) {
      item.qt = item.qt + 1;
    }

    await this.atualizaValorProduto(item);
  }

  async diminuiQtdProduto(item: ItemPedido) {
    if (item.qt && item.qt > 1) {
      item.qt = item.qt - 1;
      await this.atualizaValorProduto(item);
    }
  }

  async excluirProduto(item: ItemPedido, interno?: boolean) {
    if (!item.produtoTela.produtoEstrutura || interno) {
      this.itens.splice(this.itens.indexOf(item), 1);
      this.atualizaValores();
    } else {
      item.qt = 0;
      await this.atualizaValorProduto(item);
    }
  }

  inserirLogAcessoTela() {
    this.carregandoService.mostra('inserirLogAcessoTela');
    this.logAcessoService.InserirAcessoTela().subscribe(
      (resp) => {
        this.carregandoService.esconde('inserirLogAcessoTela');
      },
      (erro) => {
        this.carregandoService.esconde('inserirLogAcessoTela');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarCliente() {
    this.carregandoService.mostra('buscaClientes');
    this.clienteService
      .consultarPorIdCliente(this.orcamento.cliente, true)
      .subscribe(
        (cli) => {
          this.cliente = cli;

          if (!this.pCentroDistribuicao || (this.pCentroDistribuicao && !this.premissasSistema.habilitarCDPorCidade)) {
            this.estadoSelecionado = this.cliente.uf;
            this.cidadeSelecionado = this.cliente.ibge;
          }

          this.buscarCidades();

          if (this.integrador && !this.idOrcamento) {
            this.vendedorSelecionado = this.cliente.vendedor;
          }

          if (this.pCentroDistribuicao) {
            if (this.premissasSistema.habilitarCDPorCidade) {
              this.cliente.idCD = null;
              this.cdAnterior = null;
            } else {
              this.cdAnterior = this.cliente.idCD;
            }
          }

          this.carregandoService.esconde('buscaClientes');
        },
        (erro) => {
          this.carregandoService.esconde('buscaClientes');
          this.notificacaoService.erro(erro);
        }
      );
  }

  // atualiza os totais
  atualizaValores() {
    let valortotal = 0;

    if (!this.orcamento.frete || this.orcamento.frete === null) {
      this.orcamento.frete = 0;
    }

    // if (!this.orcamento.valorServico || this.orcamento.valorServico === null) {
    //   this.orcamento.valorServico = 0;
    // }

    this.itens.forEach((p) => (valortotal += p.vTotal));

    this.orcamento.valorTotal = Number(valortotal.toFixed(2));

    if (this.orcamento.valorDa) {
      this.orcamento.valorFinal = Number(
        (this.orcamento.valorTotal - this.orcamento.valorDa).toFixed(2)
      );

      if (this.orcamento.da === 0) {
        this.orcamento.valorFinal = Number(
          (this.orcamento.valorTotal - this.orcamento.valorDa).toFixed(2)
        );
      } else {
        this.orcamento.valorFinal = Number(
          (this.orcamento.valorTotal + this.orcamento.valorDa).toFixed(2)
        );
      }
    } else {
      this.orcamento.valorFinal = this.orcamento.valorTotal;
    }

    // if (this.orcamento.flag === 4) {
    //   this.orcamento.frete = Number(((this.orcamento.valorFinal * this.txFrete) / 100).toFixed(2));
    // }

    // this.orcamento.valorFinal = Number((this.orcamento.valorFinal + Number(this.orcamento.frete) + Number(this.orcamento.valorServico)).toFixed(2));
    this.orcamento.valorFinal = Number(
      (this.orcamento.valorFinal + Number(this.orcamento.frete)).toFixed(2)
    );
    this.calcularPesoBruto();
  }

  ngOnDestroy(): void { }

  finalizar(tipo) {

    if (this.itens.some(p => Number(p.pUnitario) === 0 || Number(p.qt) === 0)) {

      swal({
        title: 'ATENÇÃO!!!',
        html: 'Não foi possível continuar!! Existem produtos com preço e/ou quantidade zerados!!!',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);

    } else {

      if (this.multiFornecedores) {
        this.carregandoService.mostra('consultarFornecedorComPrecoMaisBarato');

        this.produtoService
          .consultarFornecedorComPrecoMaisBarato(
            this.itens.map((p) => p.produto),
            this.fornecedorSelecionado,
            this.orcamento.valorTotal,
            this.usarPrecoAvulso
          )
          .subscribe(
            (fornecedor: Fornecedor) => {
              this.carregandoService.esconde(
                'consultarFornecedorComPrecoMaisBarato'
              );

              if (fornecedor !== null && fornecedor !== undefined) {
                swal({
                  title: 'Atenção!!',
                  html:
                    'Fornecedor <span class="font-weight-bold">' +
                    fornecedor.descricao +
                    '</span> está com valores mais baratos deseja salvar assim mesmo?',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonClass: 'btn btn-info',
                  cancelButtonClass: 'btn btn-danger',
                  confirmButtonText: 'Sim',
                  cancelButtonText: 'Não',
                  buttonsStyling: false,
                }).then((result) => {
                  if (result.value) {
                    this.salvarOrcamento(tipo);
                  }
                });
              } else {
                this.salvarOrcamento(tipo);
              }
            },
            (err) => {
              this.carregandoService.esconde(
                'consultarFornecedorComPrecoMaisBarato'
              );
              this.notificacaoService.erro(err);
            }
          );
      } else {
        this.salvarOrcamento(tipo);
      }
    }
  }

  salvarOrcamento(tipo) {
    const pPainel = this.itens.find(p => p.produtoTela.familia === 2 || p.produtoTela.familia === 7);

    let potTotal = 0;

    if (pPainel !== undefined && pPainel !== null) {
      const potenciaPainel = pPainel.produtoTela.potencia;
      const quantidadeDePaineis = Number(pPainel.qt);

      potTotal = Number(
        ((potenciaPainel * quantidadeDePaineis) / 1000).toFixed(2)
      );
    }

    let da;
    let percentual;
    let valorDa;

    if (this.pUsarAcrescimo && this.cliente.daGI === 1) {
      da = 1;
      percentual = this.cliente.acrescimoGI;
      valorDa = Number((Number(this.orcamento.valorTotal) * this.cliente.acrescimoGI / 100).toFixed(2));
    }

    let idFornecedor;

    if (this.multiFornecedores) {
      idFornecedor = this.fornecedorSelecionado;
    }

    if (this.pCentroDistribuicao) {
      idFornecedor = this.cliente.idCD;
    }

    let qtModulos = 0;

    if (this.premissasSistema.usaDescargaCif) {
      qtModulos = this.itens.reduce((total, it) => {
        if (it.produtoTela.familia === 2) {
          return total + it.qt;
        }
        if (it.produtoTela.familia === 7) {
          return total + it.produtoTela.composicao.reduce((compTotal, comp) => {
            return comp.produtoMP.familia === 2 ? compTotal + (comp.qt * it.qt) : compTotal;
          }, 0);
        }
        return total;
      }, 0);
    }

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(DigitaCampoModalComponent, {
      width: largura > 1030 ? '1000px' : $('body').width().toString() + 'px',
      // passa os produtos já selecionados
      data: {
        origem: 2,
        tipo: tipo,
        selecionarIntegrador: !this.integrador,
        informarNome: true,
        valorProdutos: this.orcamento.valorTotal,
        ibge: this.cliente ? this.cliente.ibge : '',
        idDescarga: this.orcamento.idDescarga,
        nome: this.nome,
        cliente: this.cliente,
        idCD: this.pCentroDistribuicao
          ? this.cliente.idCD
          : (this.multiFornecedores && this.fornecedorSelecionado !== null && this.fornecedorSelecionado !== undefined ? this.fornecedorSelecionado : undefined),
        vendedor: this.vendedor,
        limDesc: this.limDesc,
        potencia: potTotal,
        avulso: true,
        da: da,
        percentual: percentual,
        valorDa: valorDa,
        valorTotalFixo: this.orcamento.valorTotalFixo,
        idFornecedor: idFornecedor,
        qtModulos: qtModulos,
        cidade: this.cidadeSelecionado,
        uf: this.estadoSelecionado,
        itens: this.itens
      },
      panelClass: 'modal-card',
      // maxHeight: '90vh',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.orcamento.comprador = result.nome;
        this.pedidoService.setFormaPagPedido(this.orcamento, result.formaPagamento);
        this.pedidoService.setCondPagPedido(this.orcamento, result.condicaoPagamento);
        if (tipo !== 0) {
          this.orcamento.vendaDireta = result.vendaDireta;
          this.clienteFaturamento = result.clienteFaturamento;
        }

        this.respostas = result.respostas;
        this.orcamento.formasPagamento = result.formasPagamento;

        this.orcamento.txLocalizacao = result.txLocalizacao;
        this.orcamento.tipoLocalizacao = result.localizacao;
        this.orcamento.da = result.da;
        this.orcamento.valorDa = Number(result.valorDa);
        this.orcamento.percentual = Number(result.percentual);
        this.orcamento.tipoFrete = Number(result.tipoFrete);
        this.orcamento.frete = Number(result.valorFrete);
        this.orcamento.entrega = Number(result.entrega);
        this.orcamento.taxaDA = Number(result.taxaDA);
        this.enderecoDeEntrega = result.enderecoEntrega;
        this.enderecoDeEntrega.ibge = Number(this.enderecoDeEntrega.ibge);
        this.orcamento.origemGI = 2;
        this.orcamento.transportadora = result.idTransportadora;

        this.orcamento.obs2 = result.enderecoEntregaCompleto;

        this.orcamento.valorTotalFixo = result.valorTotalFixo;

        this.orcamento.valorServico = Number(result.valorServico);
        this.orcamento.valorServicoLiquido = Number(result.valorLiquido);
        this.orcamento.idDescarga = result.idDescarga === null || result.idDescarga === undefined ? null : Number(result.idDescarga);

        this.orcamento.freteManual = result.freteManual;

        this.orcamento.seguros = result.seguros;
        this.orcamento.servicoEntrega = result.servicoEntrega;
        this.orcamento.valorServicoEntrega = result.valorServicoEntrega;
        this.orcamento.servicoEntregaManual = result.servicoEntregaManual;

        this.orcamento.valorProjeto = result.valorProjeto;
        this.orcamento.valorProjetoLiquido = result.valorProjetoLiquido;
        this.orcamento.tipoCIF = result.tipoCIF;
        this.orcamento.voucher = result.voucher;
        this.orcamento.dadosVoucher = result.dadosVoucher;
        this.orcamento.valorVoucher = result.valorVoucher;

        this.orcamento.idFrete = result.idFrete;

        if (!this.integrador) {
          this.orcamento.cliente = result.cliente.id;
        }

        this.comprovante = result.comprovante;
        this.confirmar = result.confirmar;
        this.orcamento.ipi = result.ipi;
        this.orcamento.ibs = result.ibs;
        this.orcamento.cbs = result.cbs;
        this.orcamento.multiFormaPagamento = result.usandoMultiFormasPagamento;
        this.orcamento.impostos = result.impostos;
        this.orcamento.valorImpostos = result.valorImpostos;
        this.orcamento.impostosPendente = result.impostoPendente;

        this.salvarPedido(tipo);
      }
    });
  }

  salvarPedido(tipo) {
    this.carregandoService.mostra('salvaPedido');

    const vendedorSelecionado = this.vendedor ? this.vendedor.idFuncion : this.usuarioLogado.id;

    this.orcamento.vendedor = this.integrador
      ? this.cliente.vendedor
      : vendedorSelecionado;
    this.orcamento.indicacao = 0;
    // this.orcamento.formaPag = this.formaDePagamentoSelecionado;
    // this.orcamento.planoPag = this.condicaoDePagamentoSelecionado;
    this.orcamento.nItens = this.itens.length;
    // this.orcamento.da = 0;
    this.orcamento.troco = 0;
    this.orcamento.nParcelas = 1;
    this.orcamento.gTotal = 0;
    this.orcamento.nCartao = '1';
    this.orcamento.bc = 0;
    this.orcamento.ext = 0;
    this.orcamento.nECF = '0';
    this.orcamento.turno = 0;
    this.orcamento.nTurno = 0;
    this.orcamento.status = 0;
    // this.orcamento.np = 0;
    // this.orcamento.percentual = 0;
    this.orcamento.nPdv = 98;
    this.orcamento.nLoja = 1;

    //this.orcamento.valorDa = 0
    //this.orcamento.percentual = 0;
    //this.orcamento.frete = 0;
    // this.orcamento.valorServico = 0;
    this.orcamento.funcDesco = 0;
    this.orcamento.data = new Date();

    if (this.multiFornecedores) {
      this.orcamento.idFornecedor = Number(this.fornecedorSelecionado);
    }

    if (this.pCentroDistribuicao) {
      this.orcamento.idFornecedor = this.cliente.idCD;
    }

    this.itens.forEach((it) => {
      it.nItem = this.itens.indexOf(it) + 1;
      it.cc = it.produtoTela.cc;
      it.comissao = 0;
      it.da = 0; // se tiver desconto é 0
      it.valorDa = 0;
      it.frete = 0;
      it.pCusto = it.produtoTela.precoCusto;
      it.percentual = 0;
      it.idCupom = this.idOrcamento ? this.idOrcamento : it.idCupom;
    });
    this.salvar(tipo);
  }

  salvar(tipo) {

    if (tipo === 1 && this.confirmar) {
      this.pedidoService.confirmarOrcamento(this.orcamento,
        this.itens,
        [],
        this.orcamento.vendaDireta ? this.clienteFaturamento : null,
        false,
        tipo === 0 ? true : false,
        false,
        this.enderecoDeEntrega, this.comprovante, this.respostas).subscribe((resp: any) => {
          this.idOrcamento = resp.idCupom;
          // this.notificacaoService.sucesso(this.texto + ' Salvo com sucesso!!!');
          this.carregandoService.esconde('salvaPedido');
          //
          this.notificacaoService.sucesso('Pedido Confirmado com sucesso!!!');
          this.router.navigate(['/pedidos']);
        }, (erro) => {
          this.carregandoService.esconde('salvaPedido');
          this.notificacaoService.erro(erro);
        });
    } else {
      this.pedidoService
        .salvar(
          this.orcamento,
          this.itens,
          [],
          this.orcamento.vendaDireta ? this.clienteFaturamento : null,
          false,
          tipo === 0 ? true : false,
          false,
          this.enderecoDeEntrega,
          this.respostas
        )
        .subscribe(
          (resp: any) => {
            this.idOrcamento = resp.idCupom;
            this.notificacaoService.sucesso((tipo === 0 ? 'Orçamento' : 'Pedido') + ' Salvo com sucesso!!!');
            this.carregandoService.esconde('salvaPedido');
            this.router.navigate([tipo === 0 ? '/orcamentos' : '/pedidos']);
          },
          (erro) => {
            this.carregandoService.esconde('salvaPedido');
            this.notificacaoService.erro(erro);
          }
        );
    }


  }

  detalhesDoProduto(produto: Produto) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(DetalheProdutoModalComponent, {
      width: $('body').width().toString() + 'px',
      // passa os produtos já selecionados
      data: {
        produto: produto,
      },
      panelClass: 'modal-card',
      maxHeight: '90vh',
    });
  }

  adicionarItensSemLayout() {
    $('#botaoProximo').click();

    this.pesquisarProdutos();
  }

  atualizaDesconto(tipo, valida) {
    if (this.orcamento.flag === 4) {
      if (tipo === 0) {
        if (!this.orcamento.percentual) {
          this.orcamento.valorDa = 0;
          this.orcamento.percentual = 0;
        } else {
          this.orcamento.valorDa = Number(
            (
              (Number(this.orcamento.valorTotal) * this.orcamento.percentual) /
              100
            ).toFixed(2)
          );
        }
      } else {
        if (!this.orcamento.valorDa) {
          this.orcamento.percentual = 0;
          this.orcamento.valorDa = 0;
        } else {
          this.orcamento.percentual =
            (this.orcamento.valorDa * 100) / Number(this.orcamento.valorTotal);
        }
      }

      this.atualizaValores();
    }
  }
  buscarVerPrecosProdutos() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarVerPrecoProdutos().subscribe(
      (f) => {
        this.mostrarValores = f.valor;
        this.carregandoService.esconde('buscarVerPrecosProdutos');
      },
      (erro) => {
        this.carregandoService.esconde('buscarVerPrecosProdutos');
        this.notificacaoService.erro(erro);
      }
    );
  }

  calcularPesoBruto() {
    this.pesoBruto = 0;
    this.itens.forEach((element: any) => {
      this.pesoBruto += element.produtoTela.peso
        ? element.produtoTela.peso * element.qt
        : 0;
    });
  }

  buscarMostrarCodErp() {
    this.carregandoService.mostra('buscarMostrarCodErp');
    this.premissasService.consultarMostrarCodErp().subscribe(
      (f) => {
        this.mostrarCodErp = f.valor;
        this.carregandoService.esconde('buscarMostrarCodErp');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMostrarCodErp');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarUsarPrecoAvulso() {
    this.carregandoService.mostra('buscarUsarPrecoAvulso');
    this.premissasService.consultarUsarPrecoAvulso().subscribe(
      (f) => {
        this.usarPrecoAvulso = f.valor;
        this.carregandoService.esconde('buscarUsarPrecoAvulso');
      },
      (erro) => {
        this.carregandoService.esconde('buscarUsarPrecoAvulso');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMultiFornecedores() {
    this.carregandoService.mostra('consultarMultiFornecedores');
    this.premissasService.consultarMultiFornecedores().subscribe(
      (f) => {
        this.multiFornecedores = f.valor;

        if (this.multiFornecedores) {
          if (this.integrador) {
            this.router.navigate(['/']);
          } else {
            this.buscarFornecedores();
          }
        }

        this.carregandoService.esconde('consultarMultiFornecedores');
      },
      (erro) => {
        this.carregandoService.esconde('consultarMultiFornecedores');
        this.notificacaoService.erro(erro);
      }
    );
  }

  alterouFornecedor() {
    if (this.itens.length > 0) {

      if (this.itens.some(p => Number(p.pUnitario) === 0)) {
        swal({
          title: 'ATENÇÃO!!!',
          html: 'Não foi possível trocar de fornecedor!! Existem produtos com preço zerado!!!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).catch(swal.noop);

        this.fornecedorSelecionado = this.fornecedorAnterior;
      } else {
        this.carregandoService.mostra('buscarFornecedores');

        this.produtoService
          .consultarPrecosFornecedoresPorIds(
            this.itens.map((p) => p.produto),
            this.fornecedorSelecionado
          )
          .subscribe(
            (valores: ProdutoFornecedorValor[]) => {
              this.carregandoService.esconde('buscarFornecedores');

              if (
                this.itens.some(
                  (p) => !valores.some((v) => v.idProduto === p.produto)
                )
              ) {
                swal({
                  title: 'Atenção!!',
                  html:
                    'Fornecedor selecionado não tem todos os itens do orçamento!!<br><br>' +
                    this.itens
                      .filter(
                        (p) => !valores.some((v) => v.idProduto === p.produto)
                      )
                      .map(
                        (p) =>
                          (this.mostrarCodErp
                            ? p.produtoTela.codErp
                            : p.produtoTela.codBarra) +
                          ' - ' +
                          p.produtoTela.descricao
                      )
                      .join('<br>'),
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-warning',
                  type: 'warning',
                }).then((result) => {
                  this.fornecedorSelecionado = this.fornecedorAnterior;
                });
              } else {
                this.fornecedorAnterior = this.fornecedorSelecionado;
                this.itens.forEach(async (p) => {
                  const valor = valores.find((v) => v.idProduto === p.produto);
                  p.produtoTela.precoAvulso = valor.precoAvulso;
                  p.produtoTela.precoCusto = valor.precoCusto;
                  p.produtoTela.precoVenda = valor.precoVenda;
                  await this.atualizaValorProduto(p);
                });
              }
            },
            (err) => {
              this.carregandoService.esconde('buscarFornecedores');
              this.notificacaoService.erro(err);
            }
          );
      }
    }
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscarFornecedores');

    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.fornecedores = forn;
        this.carregandoService.esconde('buscarFornecedores');
      },
      (err) => {
        this.carregandoService.esconde('buscarFornecedores');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarCDs() {
    this.carregandoService.mostra('buscarCDs');

    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.cds = forn;
        this.carregandoService.esconde('buscarCDs');
      },
      (err) => {
        this.carregandoService.esconde('buscarCDs');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarMostrarMsgTrocaCD() {
    this.carregandoService.mostra('buscarMostrarMsgTrocaCD');
    this.premissasService.consultarMostrarMsgTrocaCD().subscribe(
      (f) => {
        this.mostrarMsgTrocaCD = f;
        this.carregandoService.esconde('buscarMostrarMsgTrocaCD');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMostrarMsgTrocaCD');
        this.notificacaoService.erro(erro);
      }
    );
  }

  trocarCD() {

    if (this.itens === null || this.itens === undefined || this.itens.length === 0) {

      this.cdAnterior = this.cliente.idCD;

      return;
    }

    if (this.itens.some(p => Number(p.pUnitario) === 0)) {

      swal({
        title: 'ATENÇÃO!!!',
        html: 'Não foi possível trocar de centro de distribuição!! Existem produtos com preço zerado!!!',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);

      this.cliente.idCD = this.cdAnterior;

    } else {

      this.cdAnterior = this.cliente.idCD;

      this.carregandoService.mostra('trocarCD');

      this.produtoService.trocarCD(this.itens.map(p => p.produto).join(','), true, this.cliente.idCD, '7').subscribe(dados => {

        const produtos: Produto[] = dados;

        const itensAtualizados: ItemPedido[] = [];

        produtos.forEach(p => {
          const novoItem = this.itens.find(i => i.produto === p.idProduto);
          novoItem.pUnitario = p.precoVenda;
          novoItem.pCusto = p.precoCusto;
          novoItem.produto = p.idProduto;
          novoItem.produtoTela = p;
          novoItem.det1 = p.descricaoAtual;

          itensAtualizados.push(novoItem);
        });

        this.itens = [...itensAtualizados];

        this.itens.forEach(i => this.atualizaValorProduto(i));

        this.carregandoService.esconde('trocarCD');


      }, (erro) => {
        this.carregandoService.esconde('trocarCD');
      });
    }
  }

  mostrarEstoqueDoProduto(produto: Produto) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(EstoqueProdutoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: { produto, idFornecedor: this.pCentroDistribuicao ? this.cliente.idCD : null },
      panelClass: 'modal-card',
    });
  }

  private loadCidade(item?) {

    this.cidades$ = concat(
      of(item ? [item] : []), // default items
      this.cidadesInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.cidadesLoading = true)),
        switchMap((term) =>

          (this.ibgeService.consultarPorCidade(term)).pipe(
            catchError(() => of(item ? [item] : [])), // empty list on error
            tap(() => (this.cidadesLoading = false)),
          ),
        ),
      ),
    );
  }

  async buscarCidadesV2() {
    if (this.cidadeSelecionado !== null && this.cidadeSelecionado !== undefined) {
      this.cidade = await this.ibgeService.buscarCidadePorCodIGBE(this.cidadeSelecionado).toPromise();
      this.loadCidade(this.cidade);
      await this.alterouCidade();
    }
  }

  async alterouCidade() {

    if (this.pCentroDistribuicao && this.premissasSistema.habilitarCDPorCidade && this.cliente) {

      if (this.cidadeSelecionado !== null && this.cidadeSelecionado !== undefined) {
        this.cidade = await this.ibgeService.buscarCidadePorCodIGBE(this.cidadeSelecionado).toPromise();
        this.estadoSelecionado = this.cidade.uf;
        if (this.cliente.idCD != this.cidade.cd) {
          this.cliente.idCD = this.cidade.cd;
          this.trocarCD();
        }
      } else {
        this.estadoSelecionado = null;
        this.cliente.idCD = null;
        this.loadCidade();
        this.itens = [];
        this.atualizaValores();

        //this.trocarCD();
      }
    } else {

      if (this.cidadeSelecionado !== null && this.cidadeSelecionado !== undefined) {
        this.cidade = await this.ibgeService.buscarCidadePorCodIGBE(this.cidadeSelecionado).toPromise();
        this.estadoSelecionado = this.cidade.uf;
      } else {
        this.estadoSelecionado = null;
      }

    }
  }

  buscarCidades(nomeCidade?: string) {

    this.buscarCidadesV2();

  }

}
